/* App constant values to reference without exposing the actual unique codes */
const applicationTypes = Object.freeze({
  PortalProveedor: 3,
  Dashboard: 4,
  Security: 5,
  PortalPadre: 8,
  EDUESP: 9,
});

export default applicationTypes;
